import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import ILWarning from "../../assets/images/il-warning.png";
import ILSuccessOTP from "../../assets/images/il-success-otp.png";
import ILSuccess from "../../assets/images/il-success.png";
import { ReactComponent as CrossIcon } from "../../assets/icons/cross.svg";

// if setting up the CSS is tricky, you can add this to your page somewhere:
// <link rel="stylesheet" href="https://unpkg.com/react-spring-bottom-sheet/dist/style.css" crossorigin="anonymous">
import "react-spring-bottom-sheet/dist/style.css";
import ModalBottom from "../Modal/ModalBottom";
import Button from "../Button/Button";

const InformationSheet = ({ sheetDetail, setSheetDetail }) => {
  function onDismiss() {
    console.log(sheetDetail);
    if (sheetDetail?.buttonAction) {
      sheetDetail?.buttonAction();
    } else {
      setSheetDetail({
        ...sheetDetail,
        open: false,
      });
    }
  }

  function IconType() {
    switch (sheetDetail?.icon) {
      case "success":
        return <img src={ILSuccess} className="mx-auto h-32" alt="Success" />;
      case "success-otp":
        return (
          <img src={ILSuccessOTP} className="mx-auto h-32" alt="Success" />
        );
      default:
        return <img src={ILWarning} className="mx-auto h-20" alt="Warning" />;
    }
  }

  return (
    <BottomSheet
      open={sheetDetail.open}
      onDismiss={onDismiss}
      header={
        <>
          <div className="flex w-full items-center justify-between !border-none px-5 pb-4">
            <div className="flex items-center gap-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.39019 18.0983L10.6151 3.89171C11.0696 3.10655 11.2969 2.71396 11.5935 2.58211C11.8521 2.4671 12.1474 2.4671 12.4061 2.58211C12.7026 2.71396 12.9299 3.10654 13.3844 3.89171L21.6093 18.0983C22.0655 18.8863 22.2936 19.2803 22.2599 19.6037C22.2305 19.8857 22.0827 20.142 21.8534 20.3088C21.5904 20.5 21.1352 20.5 20.2246 20.5H3.77487C2.86435 20.5 2.40908 20.5 2.14613 20.3088C1.91677 20.142 1.769 19.8857 1.73959 19.6037C1.70588 19.2803 1.93398 18.8863 2.39019 18.0983Z"
                  stroke="#F04438"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 9V13M12 17H12.01"
                  stroke="#F04438"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div className="text-lg font-semibold">{sheetDetail.title}</div>
            </div>
            <button
              onClick={onDismiss}
              className="rounded-lg border border-monochrome-100 bg-white p-2 shadow-sm"
            >
              <CrossIcon />
            </button>
          </div>
          <div className="-mb-1 h-3 rounded-t-lg bg-white"></div>
        </>
      }
      snapPoints={({ minHeight }) => [minHeight]}
      defaultSnap={({ snapPoints }) => snapPoints}
    >
      <>
        <div className="w-full space-y-5 p-4">
          <p className="text-xs text-monochrome-400">{sheetDetail.detail}</p>
          {sheetDetail.children && sheetDetail.children}
          {sheetDetail.buttonAction && sheetDetail.buttonLabel && (
            <Button
              variant="gradient"
              label={sheetDetail.buttonLabel}
              onClick={sheetDetail.buttonAction}
              fullWidth
            />
          )}
        </div>
      </>
    </BottomSheet>
  );
};

export default InformationSheet;
